import { FC } from 'react';
import { TableColumns } from '../types';
import { FormattedMessage } from 'react-intl';
import { TableCell } from '@components/common/Table/TableCell/TableCell';
import { TableSortLabel } from '@components/common/Table/TableSortLabel/TableSortLabel';
import { SortDirectionEnum } from '@legacy/shared-types/enums/sort-direction.enum';
import { IHeaderCellProps } from './types';

const SortingColumns: TableColumns[] = [
  'productCategory',
  'productRange',
  'productType',
  'monthsInitial',
  'maximumFTV',
  'initialRate',
  'productFees',
  'productFeesPercentage',
  'equityShare',
];

export const HeaderCell: FC<IHeaderCellProps> = ({ order, orderBy, columnTextId, sortHandler }) => {
  return (
    <>
      {SortingColumns.includes(columnTextId) ? (
        <TableCell
          key={columnTextId}
          sortDirection={orderBy === columnTextId ? order : false}
          data-testid={'headerCell'}
        >
          <TableSortLabel
            active={orderBy === columnTextId}
            direction={orderBy === columnTextId ? order : SortDirectionEnum.ASC}
            onClick={() => sortHandler(columnTextId)}
          >
            <FormattedMessage id={`product.${columnTextId}.label`} />
          </TableSortLabel>
        </TableCell>
      ) : (
        <TableCell key={columnTextId} data-testid={'headerCell'}>
          <FormattedMessage id={`product.${columnTextId}.label`} />
        </TableCell>
      )}
    </>
  );
};
